import React, { useState } from 'react';
import { Alert, Checkbox, CircularProgress, FormControlLabel, List, ListItemButton, ListItemText } from '@mui/material';

import { usePromise } from '@paragon/client-tools';
import { designService } from '@paragon/data-connections';
import { closeCurrentPopup, Dialog } from '@paragon/popup-state';
import { naturalSortByProperty } from '@paragon/utilities';

import { getActiveStation } from '../../store/selectors/getActiveStation';
import { useAppDispatch, useAppSelector } from '../hooks';

export function ImportAssemblyGroupDialog() {
  const dispatch = useAppDispatch();
  const activeStation = useAppSelector(getActiveStation);

  const [clearExistingComponents, setClearExistingComponents] = useState(true);

  const assemblyGroupsQuery = usePromise(designService.assemblyGroups.getAll);

  if (activeStation === null || activeStation.followsSchedule) return null;

  return (
    <Dialog insistent title="Import Assembly Group" submitText="Close">
      {assemblyGroupsQuery.isError ? (
        <Alert severity="error">Error loading assembly groups</Alert>
      ) : assemblyGroupsQuery.isPending ? (
        <CircularProgress />
      ) : (
        <List>
          {naturalSortByProperty(assemblyGroupsQuery.data, (assemblyGroup) => assemblyGroup.name).map(
            (assemblyGroup) => (
              <ListItemButton
                key={assemblyGroup.guid}
                onClick={async () => {
                  dispatch(closeCurrentPopup());
                  await designService.assemblyGroups.sendToStation(
                    assemblyGroup.guid,
                    activeStation.guid,
                    clearExistingComponents,
                  );
                }}
              >
                <ListItemText primary={assemblyGroup.name} />
              </ListItemButton>
            ),
          )}
        </List>
      )}
      <FormControlLabel
        label="Clear Existing Components"
        control={
          <Checkbox
            checked={clearExistingComponents}
            onChange={(event) => setClearExistingComponents(event.target.checked)}
          />
        }
      />
    </Dialog>
  );
}
